<template>
  <div class="main-wrapper">
    <div class="menu-list" :style="{ left: showList ? '0' : '-55%' }">
      <div class="menu-item" @click="toHome">首页</div>
      <div
        class="menu-item"
        v-for="(item, index) in menulist"
        :key="index"
        @click="checkout(item.modulename)"
        v-show="item.modulename != '留言区'"
      >
        {{ item.modulename }}
      </div>
      <div class="menu-item" @click="toKnow">知识列表</div>
    </div>
    <div class="qrcode-show" v-show="qrShow" @click.stop="closeQr">
      <div class="content">
        <img :src="qrcodeShow" alt="" />
        <p>请扫描二维码</p>
        <p v-if="telePhone">
          Tel: {{ telePhone }}
          <a class="call" :href="'tel:' + telePhone">呼叫</a>
        </p>
      </div>
    </div>
    <div
      class="bottom-menu"
      v-show="bottomShow"
      :style="'background-color:' + $store.state.bgColor"
    >
      <span class="menu" @click="openMenu"
        ><img src="../../assets/more.png" alt="" />栏目</span
      >
      <span
        class="zixu"
        :style="
          'border-color:' +
          $store.state.bgColor +
          ';color:' +
          $store.state.bgColor
        "
        @click="showQrcode"
      >
        <img src="../../assets/zixun.png" alt="" />咨询
      </span>
      <span class="zhishi" @click="toKnow"
        ><img src="../../assets/knowledge.png" alt="" /> 知识</span
      >
      <div v-show="isWx" id="button"></div>
    </div>
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { Tabbar, TabItem } from "mint-ui";
var wx = require("weixin-js-sdk");
export default {
  data() {
    return {
      isWx: false,
      qrcodeShow: "",
      docmHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      bottomShow: true, //显示或者隐藏footer
      Website: "",
      telePhone: "",
      qrShow: false,
      orgName: "",
      showList: false,
      menulist: [],
      token: "",
      othertoken: "",
      orgId: "",
      requestLink: "",
      weiChatAppId: "",
      weiChatNonceStr: "",
      weiChatSignature: "",
      weiChatTimeStamp: "",
    };
  },
  methods: {
    zixun() {
      var that = this,
        ipId = that.orgId,
        token = that.token,
        url =
          "https://api.lotusdata.com/v1/organization/customerlistbyorgid/" +
          ipId +
          "?key=&start=0&limit=1",
        data = {};
      this.$axios
        .get(url, data, { headers: { Authorization: token } })
        .then(function (res) {
          if (res.data.code == "0") {
            var list = res.data.data;
            if (list.length != 0) {
              var docId = list[0].Doctorid,
                userid = that.data.userId;

              var sea_url =
                  "https://api.lotusdata.com/dialogmessage/v1/dialogsummary/summary?sender=" +
                  userid +
                  "&receiver=" +
                  docId,
                sysToken = that.data.sysToken;
              common
                .getData(sea_url, "GET", data, sysToken)
                .then(function (res) {
                  if (res.data.code == "0") {
                    if (res.data.data == null) {
                      common.navigateTo(
                        "../questionContent/questionContent?zx=1&docId=" +
                          docId +
                          "&sumid="
                      );
                    } else {
                      common.navigateTo(
                        "../questionContent/questionContent?zx=1&docId=" +
                          docId +
                          "&sumid=" +
                          res.data.data.Summaryid
                      );
                    }
                  } else {
                    wx.showToast({
                      title: "查询咨询记录失败，请重试",
                      icon: "none",
                      duration: 5000,
                    });
                  }
                });
            } else {
              console.log("没有导诊台");
            }
          } else {
            console.log("信息获取失败");
          }
        });
    },

    closeQr() {
      this.qrShow = false;
    },
    showQrcode() {
      if (this.isWx) {
        return;
      } else {
        this.qrShow = true;
      }
    },
    checkout(name) {
      this.showList = false;
      this.$router.push({
        path: "/teamcontent/index",
        query: {
          orgId: this.orgId,
          name: name,
        },
      });
    },
    toHome() {
      this.showList = false;
      this.$router.push({
        path: "/teamcontent/index",
        query: {
          orgId: this.orgId,
          name: "first",
        },
      });
    },
    toKnow() {
      this.showList = false;
      this.$router.push({
        path: "/teamcontent/knowledge",
        query: {
          orgId: this.orgId,
        },
      });
    },
    openMenu() {
      this.showList = !this.showList;
    },
    getorgInfo() {
      var TOKEN = localStorage.getItem("TOKEN");
      this.$axios
        .get("https://api.lotusdata.com/ip/v1/ipm/" + this.orgId, {
          headers: { Authorization: TOKEN },
        })
        .then(
          (res) => {
            if (res.data.code == 0) {
              var infodata = res.data.data;
              this.orgName = infodata.Ipname;
              var orgpic = infodata.Pic;
              var orgname = infodata.Ipname;

              wx.showOptionMenu();
              var titleValue = orgname;
              var linkValue =
                "https://share.litixuanjiao.com/teamcontent/index?orgId=" +
                this.orgId +
                "&name=first";
              var descValue = infodata.Summary;
              var imgUrlValue = orgpic;
              wx.ready(function () {
                // 分享给朋友
                wx.onMenuShareAppMessage({
                  title: titleValue, // 分享标题
                  link: linkValue, // 分享链接
                  desc: descValue, // 分享描述
                  imgUrl: imgUrlValue, // 分享图标
                  success: function () {
                    console.log("分享给朋友成功啦！");
                  },
                  cancel: function () {
                    console.log("分享失败");
                  },
                });
                // 分享到朋友圈
                wx.onMenuShareTimeline({
                  title: titleValue, // 分享标题
                  link: linkValue, // 分享链接
                  desc: descValue, // 分享描述
                  imgUrl: imgUrlValue, // 分享图标
                  success: function () {
                    console.log("分享朋友圈成功啦！");
                  },
                  cancel: function () {
                    console.log("分享失败");
                  },
                });
              });
            }
          },
          function () {
            console.log("数据请求失败");
          }
        );
    },
    getOther() {
      var that = this,
        token = localStorage.getItem("token");
      this.$axios
        .get(
          "https://api.lotusdata.com/operations/v1/organization/" + that.orgId,
          {
            headers: { Authorization: token },
          }
        )
        .then((res) => {
          if (res.data.code == "0" && res.data.data != null) {
            that.telePhone = res.data.data.Telephone;
            that.Website = res.data.data.Website;
          }
        });
    },
    getModalList() {
      var TOKEN = localStorage.getItem("TOKEN");
      var self = this;
      var menulist = [];
      this.$axios
        .get(
          "https://drplus.lotusdata.com/v1/studiomodule/list/" + this.orgId,
          {
            headers: { Authorization: TOKEN },
          }
        )
        .then(
          (res) => {
            if (res.data.code == 0) {
              var list = res.data.data;
              // self.showTitle = list
              let promises = list.map((item, index) => {
                return getfirstactile(item, index);
              });
              function getfirstactile(item, index) {
                return new Promise((resolve, reject) => {
                  self.$axios
                    .get(
                      "https://drplus.lotusdata.com/v1/article/contentbytags/" +
                        self.orgId +
                        "?key=" +
                        item.Modulename +
                        "&start=0&limit=5",
                      {
                        headers: { Authorization: TOKEN },
                      }
                    )
                    .then((res) => {
                      if (res.data.code == 0) {
                        var data = res.data.data;
                        resolve({
                          data: data,
                          modulename: item.Modulename,
                          moduleid: item.Id,
                        });
                      }
                    });
                });
              }
              Promise.all(promises)
                .then((allData) => {
                  allData.forEach((item) => {
                    // if (item.data != null) {
                    menulist.push({
                      modulename: item.modulename,
                      id: item.moduleid,
                      list: item.data,
                    });

                    // }
                  });
                  this.menulist = menulist;
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          },
          function () {
            console.log("数据请求失败");
          }
        );
    },
    getLoginToken() {
      var data = {
        username: "uuapp",
        password: "110113",
        refreshtoken: "0",
      };
      var that = this;
      this.$axios
        .post(
          "https://api.lotusdata.com/operations/v1/admlogin/token",
          data,
          {}
        )
        .then(function (res) {
          that.othertoken = "JWT " + res.data.token;
          localStorage.setItem("token", "JWT " + res.data.token);
          that.getOther();
        });
    },
    getToken() {
      this.$axios
        .get("https://api.lotusdata.com/v1/buser/token", {
          params: {
            username: "uuapp.li@qq.com",
            password: "123123",
            refreshtoken: 0,
          },
        })
        .then(
          (res) => {
            if (res.data.code == 0) {
              var TOKEN = res.data.token;
              this.token = "JWT " + TOKEN;
              localStorage.setItem("TOKEN", "JWT " + TOKEN);
              this.getWechatSDK();
            }
          },
          function () {
            console.log("数据请求失败");
          }
        );
    },
    getCustomer() {
      var token = localStorage.getItem("token"),
        that = this;
      this.$axios
        .get(
          "https://api.lotusdata.com/operations/v1/customershift/" + this.orgId,
          {
            headers: { Authorization: token },
          }
        )
        .then((res) => {
          if (res.data.code == 0 && res.data.data != null) {
            var docId = res.data.data[0].Doctorid,
              Token = localStorage.getItem("TOKEN");
            that.$axios
              .get("https://api.lotusdata.com/v1//doctor/" + docId, {
                headers: { Authorization: Token },
              })
              .then((sec) => {
                if (sec.data.code == 0 && sec.data.data != null) {
                  this.qrcodeShow = sec.data.data.Qrcode;
                }
              });
          }
        });
    },
    getWechatSDK() {
      //获取微信SDK
      var TOKEN = localStorage.getItem("TOKEN"),
        that = this;
      this.$axios
        .post(
          "https://api.lotusdata.com/v1/wx/jsconfig",
          {},
          {
            params: { url: this.requestLink },
            headers: { Authorization: TOKEN },
          }
        )
        .then(
          (res) => {
            if (res.data.code == "0") {
              var data = res.data.data;
              this.weiChatAppId = data.AppID;
              this.weiChatNonceStr = data.NonceStr;
              this.weiChatSignature = data.Signature;
              this.weiChatTimeStamp = Number(data.TimeStamp);
              // this.toIndex()
              this.getModalList();
              this.getCustomer();

              var ua = navigator.userAgent.toLowerCase();
              var isWeixin = ua.indexOf("micromessenger") != -1;
              that.isWx = isWeixin ? true : false;
              wx.config({
                debug: false,
                appId: data.AppID,
                timestamp: Number(data.TimeStamp),
                nonceStr: data.NonceStr,
                signature: data.Signature,
                jsApiList: [
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline",
                  "onMenuShareQQ",
                  "onMenuShareWeibo",
                  "onMenuShareQZone",
                ],
                openTagList: ["wx-open-launch-weapp"],
              });
              var dom = document.getElementById("button");
              dom.innerHTML = `<wx-open-launch-weapp style="display:block;width:100%;height:100%;" id="launch-btn" username="gh_526bd41ff21a" path="\/page/department/department.html?ipId=${this.orgId}">
                                        <script type="text\/wxtag-template">
                                            <button style="padding:0;width:66px;height:60px;opacity: 0;">
                                            <\/button>
                                        <\/script>
                                    <\/wx-open-launch-weapp>`;
              var launchBtn = document.getElementById("launch-btn");
              if (!launchBtn) {
                return;
              }
              launchBtn.addEventListener("launch", function (e) {
                console.log("success");
              });
              launchBtn.addEventListener("error", function (e) {
                console.log("fail", e.detail);
              });
            }
          },
          function () {
            console.log("数据请求失败");
          }
        );
    },
  },
  mounted() {
    var that = this;
    window.onresize = () => {
      return (() => {
        this.showHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
    runloop();
    function runloop() {
      // var token = localStorage.getItem('TOKEN');
      var href = window.location.href.split("#")[0];
      that.orgId = that.$route.query.orgId;
      localStorage.setItem("orgId", that.orgId);
      that.requestLink = href;
      that.getLoginToken();
      that.getToken();
    }
  },
  //监听页面显示高度，防止软键盘弹出影响布局
  watch: {
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        //隐藏
        this.bottomShow = false;
      } else {
        //显示
        this.bottomShow = true;
      }
    },
    $route(to, from) {
      if (to.name == "index") {
        var orgId = this.$route.query.orgId;
        if (this.orgId != orgId) {
          this.orgId = orgId;
          this.getModalList();
          this.getOther();
          this.getorgInfo();
        } else {
        }
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.main-wrapper {
  width: 100%;
  // height: 100%;
  .main-head {
    color: #fff;
    width: 100%;
    height: 50px;
    background-color: #509d9f;
    text-align: center;
    position: fixed;
    z-index: 10;
    .org-name {
      vertical-align: top;
      height: 100%;
      line-height: 50px;
      display: inline-block;
      width: 70%;
    }
    .menu,
    .zixu {
      display: inline-block;
      height: 100%;
      width: 13%;
      font-size: 12px;
      img {
        margin: 5px 0 0 10px;
        display: block;
        height: 50%;
      }
    }
  }
  .menu-list {
    width: 50%;
    // padding: 20px 0 0 20px;
    // border: 1px solid black;
    background-color: #fff;
    box-shadow: 4px 0 8px 0 rgba(0, 0, 0, 0.1);
    height: calc(100% - 44px);
    position: fixed;
    z-index: 10;
    transition: 0.3s left ease-in-out;
    .menu-item {
      padding-left: 10px;
      // width: 100%;
      height: 40px;
      line-height: 40px;
      display: block;
      border-bottom: 1px solid #e5e5e5;
    }
  }
  .main-content {
    padding-bottom: 50px;
    height: calc(100% - 50px);
    width: 100%;
    overflow: auto;
  }
  .qrcode-show {
    position: fixed;
    z-index: 20;
    width: 100%;
    height: 100%;
    background-color: rgba(135, 135, 135, 0.5);
    .content {
      text-align: center;
      background-color: #fff;
      width: 60%;
      height: 250px;
      border-radius: 5px;
      margin: 100px auto;
      img {
        width: 80%;
      }
      p {
        margin-bottom: 5px;
      }
    }
    .call {
      background-color: #509d9f;
      color: #fff;
      padding: 5px;
      border-radius: 4px;
    }
  }
  .bottom-menu {
    color: #fff;
    width: 100%;
    height: 45px;
    background-color: #509d9f;
    text-align: center;
    position: fixed;
    z-index: 30;
    bottom: -1px;
    .menu,
    .zhishi {
      text-align: center;
      display: inline-block;
      height: 100%;
      width: 30%;
      font-size: 12px;
      vertical-align: top;
      img {
        margin: 3px auto 2px;
        display: block;
        height: 50%;
      }
    }
    .zixu {
      padding: 10px;
      margin: 0 10px;
      position: relative;
      display: inline-block;
      bottom: 25px;
      width: 45px;
      height: 45px;
      border: 7px solid #509d9f;
      border-radius: 50%;
      background-color: #fff;
      color: #509d9f;
      img {
        margin: 0px auto;
        display: block;
        height: 70%;
      }
    }
  }
  #button {
    /*display: inline-block;*/
    position: absolute;
    width: 66px;
    height: 66px;
    top: -20px;
    left: calc(50% - 33px);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/newOrg/orgHome.vue